import { ID365MarketingFromData } from './d365-marketing-from.data';
import { ID365MarketingFromProps } from './d365-marketing-from.props.autogenerated';

export interface ID365MarketingFromViewProps extends ID365MarketingFromProps<ID365MarketingFromData> {}

const D365MarketingFrom = (props: ID365MarketingFromProps<ID365MarketingFromData>) => {
    return props.renderView(props);
};

export default D365MarketingFrom;
